import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { Link } from "react-router-dom";
import { DetailsValueLinkType, getSearchURL } from "../../title/SearchLink";
import React from "react";

export function ResourceSeriesLink({
  resource,
}: {
  resource: ResourceDWR | ResourceView;
}) {
  if (resource?.mainSeries) {
    return (
      <>
        <Link
          to={getSearchURL(
            resource.mainSeries,
            DetailsValueLinkType.seriestitle
          )}
        >
          {resource.mainSeries}
        </Link>{" "}
        {resource.mainSeriesSubv}
      </>
    );
  }

  return null;
}
